import type { CSSProperties, ElementType, FC, ReactNode } from 'react'

import { useInView } from '@/hooks/use-in-view'

interface InViewProps {
    children?: ReactNode
    as?: ElementType
    className?: string
    style?: CSSProperties
    rootMargin?: string
    id?: string
}

/**
 * Marks its children as revealed once scrolled into view, which starts the
 * CSS-driven chart animations (.bar-grow, .pop-in and .draw-path).
 */
export const InView: FC<InViewProps> = ({
    children,
    as: Tag = 'div',
    className,
    style,
    rootMargin = '0px 0px -12% 0px',
    id
}) => {
    const { ref, inView } = useInView<HTMLElement>({ rootMargin })

    return (
        <Tag
            ref={ref}
            id={id}
            data-chart=''
            data-revealed={inView ? '' : undefined}
            className={className}
            style={style}
        >
            {children}
        </Tag>
    )
}
